import React, { useState } from 'react';

const AIMentor = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {open ? (
        <div className="bg-white p-4 rounded-xl shadow-xl w-72">
          <div className="text-blue-700 font-bold mb-2">🤖 AI Mentor Assistant</div>
          <p className="text-sm text-gray-700">Need help with this module? Ask me anything!</p>
          <button onClick={() => setOpen(false)} className="mt-2 text-xs text-blue-500 underline">
            Close
          </button>
        </div>
      ) : (
        <button className="bg-blue-700 text-white p-3 rounded-full shadow-md" onClick={() => setOpen(true)}>
          💬
        </button>
      )}
    </div>
  );
};

export default AIMentor;
